import src from '../../assets/coins/bnb.webp';

type Props = {
  size?: number;
  className?: string;
};

export function BnbIcon({ size = 44, className }: Props) {
  return (
    <img
      src={src}
      alt=""
      aria-label="BNB"
      width={size}
      height={size}
      draggable={false}
      className={`shrink-0 rounded-full object-cover ${className ?? ''}`}
      style={{ width: size, height: size }}
    />
  );
}
